import { SelectorPageStatus } from "@ficatranquilo/contabilidade.com-ui";

const VIEW_OPTIONS = [
  { label: "Empresa", value: "company" },
  { label: "Colaborador", value: "employee" },
];

/**
 * Troca entre a Visão Empresa e a Visão Colaborador, para o EMP com permissões da
 * empresa. São as abas segmentadas da lib (`SelectorPageStatus $variant="segmented"`),
 * no `$menuStart` do Header. `value`: "company" | "employee"; `onChange(mode)`.
 */
export default function ViewSwitch({ value = "employee", onChange }) {
  const selected = VIEW_OPTIONS.find((option) => option.value === value) || VIEW_OPTIONS[1];

  return (
    <SelectorPageStatus
      selected={selected}
      options={VIEW_OPTIONS}
      onChange={(option) => {
        if (option.value !== value) onChange?.(option.value);
      }}
      $variant="segmented"
    />
  );
}
